import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 300px;
  background: url('/icones.png') center repeat-x #2253f5;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-family: Montserrat;
  font-weight: bold;

  font-size: 48px;
  color: #ffffff;
  text-transform: uppercase;

  div.category {
    font-size: 16px;
    color: #2253f5;
    background: white;

    padding: 7px;
    text-align: center;
  }

  div.title {
    text-transform: none;
    max-width: 585px;
    margin-top: 12px;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    color: #ffffff;
  }
`;
